export interface ServiceItem {
  id: string;
  category: "residential" | "commercial";
  icon: string;
  title: string;
  description: string;
  from?: string;
  image: string;
}

export const residentialServices: ServiceItem[] = [
  {
    id: "fault-finding",
    category: "residential",
    icon: "ri-search-eye-line",
    title: "Fault finding",
    description: "Tracking down trips, no-power rooms and mystery faults — quickly and neatly.",
    from: "£85",
    image:
      "https://readdy.ai/api/search-image?query=Close%20up%20of%20a%20UK%20electrician%20hands%20using%20a%20multimeter%20on%20a%20domestic%20consumer%20unit%20in%20a%20London%20flat%20hallway%2C%20warm%20natural%20daylight%2C%20realistic%20detail%2C%20clean%20editorial%20photography%20with%20soft%20shadows&width=640&height=480&seq=service-fault-01&orientation=landscape",
  },
  {
    id: "socket-switch",
    category: "residential",
    icon: "ri-plug-line",
    title: "Socket & switch repairs",
    description: "Replacements, upgrades and dead sockets sorted with tidy finishing.",
    from: "£55",
    image:
      "https://readdy.ai/api/search-image?query=British%20electrician%20carefully%20installing%20a%20new%20white%20double%20wall%20socket%20on%20a%20freshly%20painted%20cream%20wall%20in%20a%20London%20terraced%20house%2C%20close%20up%2C%20warm%20natural%20light%2C%20realistic%20editorial%20photography&width=640&height=480&seq=service-socket-02&orientation=landscape",
  },
  {
    id: "lighting",
    category: "residential",
    icon: "ri-lightbulb-line",
    title: "Lighting installation",
    description: "Pendants, spotlights, wall lights and dimmers fitted in living rooms and kitchens.",
    from: "£75",
    image:
      "https://readdy.ai/api/search-image?query=Warm%20interior%20of%20a%20London%20living%20room%20with%20a%20new%20pendant%20light%20being%20installed%20by%20a%20UK%20electrician%20on%20a%20ladder%2C%20cosy%20evening%20light%2C%20soft%20shadows%2C%20realistic%20editorial%20photography&width=640&height=480&seq=service-light-03&orientation=landscape",
  },
  {
    id: "consumer-unit",
    category: "residential",
    icon: "ri-dashboard-3-line",
    title: "Consumer unit checks",
    description: "Fuse box inspections, RCD testing and clear advice on upgrades.",
    from: "£95",
    image:
      "https://readdy.ai/api/search-image?query=A%20clean%20modern%20UK%20consumer%20unit%20with%20white%20circuit%20breakers%20mounted%20in%20a%20cupboard%20of%20a%20London%20home%2C%20close%20up%20detail%2C%20cool%20neutral%20daylight%2C%20realistic%20editorial%20photography&width=640&height=480&seq=service-cu-04&orientation=landscape",
  },
  {
    id: "safety-check",
    category: "residential",
    icon: "ri-shield-check-line",
    title: "Electrical safety checks",
    description: "Periodic inspections for homeowners who want peace of mind.",
    from: "£120",
    image:
      "https://readdy.ai/api/search-image?query=UK%20electrician%20holding%20a%20clipboard%20and%20checking%20readings%20on%20a%20test%20meter%20in%20a%20bright%20London%20flat%20hallway%2C%20warm%20natural%20light%2C%20clean%20interior%2C%20realistic%20editorial%20photography&width=640&height=480&seq=service-safe-05&orientation=landscape",
  },
  {
    id: "landlord-cert",
    category: "residential",
    icon: "ri-file-text-line",
    title: "Landlord EICR certificates",
    description: "Full EICR reports for rental properties, delivered promptly.",
    from: "£140",
    image:
      "https://readdy.ai/api/search-image?query=Close%20up%20of%20an%20EICR%20certificate%20document%20and%20a%20test%20meter%20on%20a%20wooden%20kitchen%20counter%20in%20a%20London%20rental%20flat%2C%20warm%20natural%20light%2C%20realistic%20editorial%20photography&width=640&height=480&seq=service-eicr-06&orientation=landscape",
  },
  {
    id: "ev-charger",
    category: "residential",
    icon: "ri-charging-pile-2-line",
    title: "EV charger checks",
    description: "Installation support and safety checks for home EV chargers.",
    from: "£150",
    image:
      "https://readdy.ai/api/search-image?query=A%20wall%20mounted%20home%20EV%20charger%20on%20the%20brick%20exterior%20of%20a%20London%20terraced%20house%20with%20a%20small%20electric%20car%20nearby%2C%20soft%20natural%20daylight%2C%20realistic%20editorial%20photography&width=640&height=480&seq=service-ev-07&orientation=landscape",
  },
  {
    id: "outdoor-lighting",
    category: "residential",
    icon: "ri-sun-line",
    title: "Outdoor lighting",
    description: "Garden lights, porch lights and outdoor sockets neatly installed.",
    from: "£95",
    image:
      "https://readdy.ai/api/search-image?query=Warm%20outdoor%20wall%20light%20mounted%20by%20a%20black%20front%20door%20of%20a%20London%20terraced%20brick%20house%20at%20dusk%2C%20soft%20golden%20glow%2C%20realistic%20editorial%20photography&width=640&height=480&seq=service-out-08&orientation=landscape",
  },
];

export const commercialServices: ServiceItem[] = [
  {
    id: "shop-repairs",
    category: "commercial",
    icon: "ri-store-2-line",
    title: "Small shop repairs",
    description: "Electrical fixes for local shops, cafés and independent retailers.",
    from: "£95",
    image:
      "https://readdy.ai/api/search-image?query=Interior%20of%20a%20cosy%20London%20independent%20coffee%20shop%20with%20an%20electrician%20quietly%20checking%20a%20lighting%20fixture%20near%20the%20counter%2C%20warm%20amber%20light%2C%20realistic%20editorial%20photography&width=640&height=480&seq=service-shop-01&orientation=landscape",
  },
  {
    id: "office-lighting",
    category: "commercial",
    icon: "ri-lightbulb-flash-line",
    title: "Office lighting",
    description: "LED replacements, task lighting and clean office rewires.",
    from: "£120",
    image:
      "https://readdy.ai/api/search-image?query=Small%20London%20office%20with%20a%20UK%20electrician%20installing%20new%20LED%20panel%20lights%20above%20a%20wooden%20meeting%20table%2C%20soft%20natural%20daylight%20through%20windows%2C%20realistic%20editorial%20photography&width=640&height=480&seq=service-office-02&orientation=landscape",
  },
  {
    id: "safety-inspection",
    category: "commercial",
    icon: "ri-file-shield-2-line",
    title: "Safety inspections",
    description: "Detailed inspections for small business premises and landlords.",
    from: "£175",
    image:
      "https://readdy.ai/api/search-image?query=Close%20up%20of%20a%20UK%20electrician%20inspecting%20a%20commercial%20distribution%20board%20in%20a%20small%20London%20office%20cupboard%2C%20focused%20detail%2C%20neutral%20daylight%2C%20realistic%20editorial%20photography&width=640&height=480&seq=service-safety-03&orientation=landscape",
  },
  {
    id: "pat-testing",
    category: "commercial",
    icon: "ri-shield-flash-line",
    title: "PAT testing guidance",
    description: "Advice, planning and referrals for portable appliance testing.",
    from: "£85",
    image:
      "https://readdy.ai/api/search-image?query=UK%20electrician%20performing%20PAT%20testing%20on%20office%20electronics%20with%20a%20yellow%20test%20device%20on%20a%20wooden%20desk%20in%20a%20small%20London%20studio%20office%2C%20soft%20daylight%2C%20realistic%20editorial%20photography&width=640&height=480&seq=service-pat-04&orientation=landscape",
  },
  {
    id: "commercial-cu",
    category: "commercial",
    icon: "ri-dashboard-line",
    title: "Consumer unit checks",
    description: "Distribution board inspections for small commercial premises.",
    from: "£145",
    image:
      "https://readdy.ai/api/search-image?query=Modern%20commercial%20distribution%20board%20with%20labelled%20circuit%20breakers%20in%20a%20London%20small%20business%20cupboard%2C%20clean%20detail%20shot%2C%20neutral%20daylight%2C%20realistic%20editorial%20photography&width=640&height=480&seq=service-ccu-05&orientation=landscape",
  },
  {
    id: "maintenance",
    category: "commercial",
    icon: "ri-tools-line",
    title: "Maintenance visits",
    description: "Regular check-ins to keep your shop or office electrically healthy.",
    from: "£95",
    image:
      "https://readdy.ai/api/search-image?query=UK%20electrician%20in%20navy%20workwear%20carrying%20a%20tool%20bag%20walking%20into%20a%20small%20London%20shopfront%2C%20warm%20morning%20light%2C%20realistic%20editorial%20photography&width=640&height=480&seq=service-maint-06&orientation=landscape",
  },
];

export const heroServiceCards = [
  {
    id: "repair",
    icon: "ri-tools-fill",
    title: "I need a repair",
    subtitle: "No power, faulty socket or tripping fuse box? Choose a time and I'll take a look.",
    tag: "Same-week slots",
  },
  {
    id: "installation",
    icon: "ri-lightbulb-flash-fill",
    title: "I need an installation",
    subtitle: "Pendants, sockets, spots or EV chargers — clean, tidy fitting with clear pricing.",
    tag: "Guide from £75",
  },
  {
    id: "safety",
    icon: "ri-shield-check-fill",
    title: "I need a safety check",
    subtitle: "EICR reports, landlord certificates and full periodic inspections.",
    tag: "EICR ready",
  },
];